import { SearchOptions } from '@trustero/trustero-api-web/lib/search/search_pb'
import { MetadataSearchResponse, SearchableData } from './search.types'
import { getShouldExclude, getShouldInclude } from './search.helpers'

export const performMetadataSearch = <T>(
  items: SearchableData<T>[],
  searchOptions: SearchOptions,
): MetadataSearchResponse => {
  // get the ids to exclude
  const excludedIds = items
    .filter((item) => {
      const searchableText = item.searchableText.toLowerCase()
      return getShouldExclude(searchableText, searchOptions)
    })
    .map((item) => item.id)
    .filter((id): id is string => id !== undefined)
  // get the ids to include
  const includedIds = items
    .filter((item) => {
      const searchableText = item.searchableText.toLowerCase()
      return getShouldInclude(searchableText, searchOptions)
    })
    .map((item) => item.id)
    .filter((id): id is string => id !== undefined)
  // get the unique list of metaData matches and content matches, keeping the original order of the items
  return {
    includedIds,
    excludedIds,
  }
}
